<template>
	<form action="" @submit.prevent="">
		<div class="row" v-if="inputs.length">
			<template v-for="(input, indexInput) in inputs">
				<slot :name="'input-' + input.nome">
					<component
						:key="indexInput"
						:is="carregarTipoInput(input)"
						:class="carregarInputClass(input)"
						:label="input.label"
						v-model="form[input.nome]"
						v-bind="input"
					>
					</component>
				</slot>
			</template>
		</div>
		<slot></slot>
	</form>
</template>

<script>
export default {
	props: {
		inputs: {
			type: Array,
			default: () => []
		},
		form: {
			type: Object,
			default: () => {
				return {}
			}
		}
	},
	watch: {
		'inputs.length': (novoValor, antigoValor) => {
			if (novoValor !== antigoValor) {
				this.inputs.forEach((input) => {
					this.$set(this.form, input.nome, '')
				})
			}
		}
	},
	mounted() {
		this.inputs.forEach((input) => {
			this.$set(this.form, input.nome, '')
		})
	},
	methods: {
		carregarTipoInput(input) {
			return input.tipo ? input.tipo : 'input-text'
		},
		carregarInputClass(input) {
			return input.class ? input.class : 'col-xs-12 col-md-3 form-group'
		}
	}
}
</script>